import { INFINITE_SCROLL_DIRECTION_UP, INFINITE_SCROLL_DIRECTION_DOWN } from "logview/Constants";
export const isInfiniteScrollUp = (infiniteScrollDirection) => infiniteScrollDirection === INFINITE_SCROLL_DIRECTION_UP;
export const isInfiniteScrollDown = (infiniteScrollDirection) => infiniteScrollDirection === INFINITE_SCROLL_DIRECTION_DOWN;
